module.exports = __webpack_public_path__ + "assets/b15230d2b12488ff229a9e7e6bfdfc7a.jpg";